"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var button_1 = __importDefault(require("@paprika/button"));
var Table_1 = __importDefault(require("@acl-services/wasabicons/lib/Table"));
var Clipboard_1 = __importDefault(require("@acl-services/wasabicons/lib/Clipboard"));
var NotepadExclamation_1 = __importDefault(require("@acl-services/wasabicons/lib/NotepadExclamation"));
var Folder_1 = __importDefault(require("@acl-services/wasabicons/lib/Folder"));
var User_1 = __importDefault(require("@acl-services/wasabicons/lib/User"));
var ArrowRight_1 = __importDefault(require("@acl-services/wasabicons/lib/ArrowRight"));
var NumberConverter_1 = __importDefault(require("../Utils/NumberConverter/NumberConverter"));
var NavPanelUtils_1 = require("../NavPanelUtils/NavPanelUtils");
var l10n_1 = require("@paprika/l10n");
require("acl-icon-font/dist/css/main.scss");
require("./NavTreeItem.scss");
var NavTreeItem = function (_a) {
    var id = _a.id, projectId = _a.projectId, controlId = _a.controlId, controlTestId = _a.controlTestId, name = _a.name, type = _a.type, expanded = _a.expanded, path = _a.path, itemCount = _a.itemCount, userCount = _a.userCount, onCaretClick = _a.onCaretClick, onLinkClick = _a.onLinkClick, parentType = _a.parentType, location = _a.location, searchValues = _a.searchValues, childItems = _a.childItems;
    var i18n = l10n_1.useI18n();
    var handleCaretClick = function (e) {
        e.preventDefault();
        if (onCaretClick) {
            onCaretClick(type, id);
        }
    };
    var handleLinkClick = function (e) {
        if (onLinkClick) {
            onLinkClick(e, type, { id: id, projectId: projectId, controlId: controlId, controlTestId: controlTestId }, path);
        }
    };
    var renderName = function () {
        if (NavPanelUtils_1.isHeaderType(type) || !searchValues || searchValues.length === 0) {
            return name;
        }
        var searchName = name.toLowerCase();
        var indices = [];
        searchValues.forEach(function (searchValue) {
            indices = indices.concat(getSearchHighlightIndices(searchValue, searchName));
        });
        var highlightedIndices = [];
        var _loop_1 = function (i) {
            var isHighlighted = false;
            indices.forEach(function (index) {
                if (i >= index[0] && i <= index[1]) {
                    isHighlighted = true;
                }
            });
            highlightedIndices.push(isHighlighted);
        };
        for (var i = 0; i < name.length; i++) {
            _loop_1(i);
        }
        return generateMarkedName(name, highlightedIndices);
    };
    var getSearchHighlightIndices = function (searchValue, name) {
        var indices = [];
        var startIndex = 0;
        var searchStringLength = searchValue.length;
        var index = name.indexOf(searchValue, startIndex);
        while (index !== -1) {
            indices.push([index, index + searchValue.length - 1]);
            startIndex = index + searchStringLength;
            index = name.indexOf(searchValue, startIndex);
        }
        return indices;
    };
    var generateMarkedName = function (name, highlightedIndices) {
        var highlightedName = [];
        var stringBuffer = '';
        var markedBuffer = '';
        for (var i = 0; i < name.length; i++) {
            if (highlightedIndices[i]) {
                markedBuffer += name[i];
                if (stringBuffer) {
                    highlightedName.push(stringBuffer);
                    stringBuffer = '';
                }
            }
            else {
                stringBuffer += name[i];
                if (markedBuffer) {
                    highlightedName.push(react_1.default.createElement("mark", { key: type + "_" + id + "_" + i, className: "nav-tree-item__name--search-highlight" }, markedBuffer));
                    markedBuffer = '';
                }
            }
        }
        if (stringBuffer) {
            highlightedName.push(stringBuffer);
        }
        if (markedBuffer) {
            highlightedName.push(react_1.default.createElement("mark", { key: type + "_" + id + "_last", className: "nav-tree-item__name--search-highlight" }, markedBuffer));
        }
        return highlightedName;
    };
    var renderItemCount = function () {
        if (parentType === NavPanelUtils_1.ItemType.Table.Reporting) {
            return;
        }
        var count = itemCount;
        var childItemCountTypes = [NavPanelUtils_1.ItemType.Header.Interpretations, NavPanelUtils_1.ItemType.Header.Metrics, NavPanelUtils_1.ItemType.Header.Triggers];
        if (childItemCountTypes.includes(type)) {
            count = childItems && childItems.length;
        }
        if (count === null || count === undefined) {
            if (type == NavPanelUtils_1.ItemType.Records) {
                return react_1.default.createElement("span", { className: "nav-tree-item__item-count" }, "( \u2014 )");
            }
            return null;
        }
        return react_1.default.createElement("span", { className: "nav-tree-item__item-count" }, "(" + NumberConverter_1.default.numberWithMetricAffix(count) + ")");
    };
    var renderUserCount = function () {
        if (userCount === null || userCount === undefined) {
            return null;
        }
        return (react_1.default.createElement("span", { className: "nav-tree-item__user-count" },
            react_1.default.createElement(User_1.default, { "data-qa-anchor": "UserCountIcon" }),
            userCount));
    };
    var className = classnames_1.default('nav-tree-item', {
        'nav-tree-item--highlight': NavPanelUtils_1.NavPanelUtils.shouldHighlight(location, type, id, expanded, controlTestId),
    });
    return (react_1.default.createElement("span", { className: className, id: "nav-item_" + type + "_" + id },
        renderCaret(name, type, expanded, handleCaretClick),
        react_1.default.createElement("a", { href: path, className: "nav-tree-item__name", onClick: handleLinkClick },
            renderItemIcon(type),
            renderName(),
            renderItemCount(),
            renderUserCount())));
};
NavTreeItem.propTypes = {
    id: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
    projectId: prop_types_1.default.number,
    controlId: prop_types_1.default.number,
    controlTestId: prop_types_1.default.number,
    name: prop_types_1.default.string.isRequired,
    type: prop_types_1.default.string.isRequired,
    expanded: prop_types_1.default.bool,
    path: prop_types_1.default.string.isRequired,
    itemCount: prop_types_1.default.number,
    userCount: prop_types_1.default.number,
    onCaretClick: prop_types_1.default.func.isRequired,
    onLinkClick: prop_types_1.default.func.isRequired,
    parentType: prop_types_1.default.string,
    location: prop_types_1.default.object,
    searchValues: prop_types_1.default.array,
    childItems: prop_types_1.default.array,
    locale: prop_types_1.default.string,
};
NavTreeItem.defaultProps = {
    location: {},
    projectId: null,
    controlId: null,
    controlTestId: null,
    expanded: false,
    itemCount: null,
    userCount: null,
    parentType: '',
    searchValues: [],
    childItems: [],
    locale: 'en',
};
var renderCaret = function (name, type, expanded, handleCaretClick) {
    var i18n = l10n_1.useI18n();
    var noCaretItemTypes = [NavPanelUtils_1.ItemType.Interpretation, NavPanelUtils_1.ItemType.Metric, NavPanelUtils_1.ItemType.Trigger];
    if (noCaretItemTypes.includes(type)) {
        return null;
    }
    if (type === NavPanelUtils_1.ItemType.Records || type === NavPanelUtils_1.ItemType.Storyboard) {
        return react_1.default.createElement("div", { className: "nav-tree-item__caret-spacer" });
    }
    var caretClass = classnames_1.default('nav-tree-item__caret', { 'nav-tree-item__caret--is-expanded': expanded });
    var label = expanded
        ? i18n.t('left_navigation.collapse') + " " + name
        : i18n.t('left_navigation.expand') + " " + name;
    return (react_1.default.createElement(button_1.default.Icon, { onClick: handleCaretClick, "aria-label": label },
        react_1.default.createElement(ArrowRight_1.default, { className: caretClass })));
};
var renderItemIcon = function (type) {
    var _a;
    var iconMap = (_a = {},
        _a[NavPanelUtils_1.ItemType.Table.DataAnalytic] = Table_1.default,
        _a[NavPanelUtils_1.ItemType.Table.Reporting] = Table_1.default,
        _a[NavPanelUtils_1.ItemType.Table.Survey] = Clipboard_1.default,
        _a[NavPanelUtils_1.ItemType.Table.EventReport] = NotepadExclamation_1.default,
        _a[NavPanelUtils_1.ItemType.Control] = Folder_1.default,
        _a);
    var IconComponent = iconMap[type];
    if (!IconComponent) {
        return null;
    }
    return react_1.default.createElement(IconComponent, { "data-qa-anchor": type + "Icon" });
};
exports.default = NavTreeItem;
//# sourceMappingURL=NavTreeItem.js.map